// src/components/LanguageSelector.js
import { useState, useEffect, useRef } from 'react';
import styles from '../assets/styles/LanguageSelector.module.css';
import useLanguage from '../hooks/useLanguage';

export default function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const languages = {
    vi: { label: 'Tiếng Việt', flag: '/images/vn-flag.svg' },
    en: { label: 'English', flag: '/images/en-flag.svg' },
  };

  // Đóng dropdown khi click ra ngoài
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <div className={styles.selected} onClick={() => setOpen(!open)}>
        <img src={languages[language].flag} alt={language} />
        <span className={styles.arrow}>▾</span>
      </div>
      {open && (
        <ul className={styles.menu}>
          {Object.entries(languages).map(([code, lang]) => (
            <li key={code} onClick={() => {
              changeLanguage(code);
              setOpen(false);
            }}>
              <img src={lang.flag} alt={code} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
